import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/skiclub-lienz-logo.png'


const _hoisted_1 = { class: "main-app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      title: "SCL Weltcup",
      alt: "SCL Weltcup"
    })
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "username"
}
const _hoisted_4 = {
  class: "content-app",
  ref: "domContentApp"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComSidebar = _resolveComponent("ComSidebar")!
  const _component_UiIconButton = _resolveComponent("UiIconButton")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["view-app", _ctx.viewClass])
  }, [
    (_ctx.showSidebar)
      ? (_openBlock(), _createElementBlock("aside", {
          key: 0,
          class: _normalizeClass(["sidebar", { 'is-active': _ctx.showSidebarNav}])
        }, [
          _createVNode(_component_ComSidebar)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", {
        ref: "domHeaderApp",
        class: _normalizeClass(["header-app", 'header-app-' + _ctx.routeName])
      }, [
        _createVNode(_component_UiIconButton, {
          icon: _ctx.icons.burger,
          class: "togglenav",
          title: _ctx.$t('button.menu'),
          onOnClick: _ctx.handleToggleNav
        }, null, 8, ["icon", "title", "onOnClick"]),
        _withDirectives(_createVNode(_component_UiIconButton, {
          icon: _ctx.icons.arrowright,
          label: _ctx.$t('button.back'),
          class: "header-back",
          onOnClick: _ctx.handleGoBack
        }, null, 8, ["icon", "label", "onOnClick"]), [
          [_vShow, _ctx.showBackButton]
        ]),
        _hoisted_2,
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.userInitials), 1))
          : _createCommentVNode("", true),
        (_ctx.user)
          ? (_openBlock(), _createBlock(_component_UiIconButton, {
              key: 1,
              icon: _ctx.icons.logout,
              class: "logout",
              title: _ctx.$t('button.logout'),
              onOnClick: _ctx.handleLogout
            }, null, 8, ["icon", "title", "onOnClick"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("main", _hoisted_4, [
        (_openBlock(), _createBlock(_component_router_view, { key: _ctx.key }))
      ], 512),
      _createElementVNode("footer", {
        class: _normalizeClass(["footer-app", 'footer-app-' + _ctx.routeName]),
        ref: "domFooterApp"
      }, null, 2)
    ])
  ], 2))
}